/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { alimTalkLogControllerSearch } from '../fn/alim-talk-log/alim-talk-log-controller-search';
import { AlimTalkLogControllerSearch$Params } from '../fn/alim-talk-log/alim-talk-log-controller-search';
import { AlimTalkLogDto } from '../models/alim-talk-log-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class AlimTalkLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `alimTalkLogControllerSearch()` */
  static readonly AlimTalkLogControllerSearchPath = '/api/api/v1/alim-talk/log/search';

  /**
   * 알림톡 발송 로그 검색 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `alimTalkLogControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  alimTalkLogControllerSearch$Response(params?: AlimTalkLogControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<AlimTalkLogDto>;
}>> {
    return alimTalkLogControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 알림톡 발송 로그 검색 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `alimTalkLogControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  alimTalkLogControllerSearch(params?: AlimTalkLogControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<AlimTalkLogDto>;
}> {
    return this.alimTalkLogControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<AlimTalkLogDto>;
}>): OffsetPaginationDto & {
'items'?: Array<AlimTalkLogDto>;
} => r.body)
    );
  }

}
